import { useState, forwardRef, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';
import SeccionPageHeader from '../Utils/SeccionPageHeader.jsx';
import apiService from '../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import { useAuth } from '../../Auth/AuthContext.jsx';
import CargandoSpinner from '../Utils/CargandoSpinner.jsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendar } from 'react-icons/fa';
import Select from 'react-select';
import { Card, CardBody, CardHeader } from 'react-bootstrap';

const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: 'none',
            background: 'none',
            padding: 0,
            width: '100%'
        }}
    >
        <input
            value={value}
            readOnly
            className='widthCalendar'
            tabIndex={-1}
            style={{
                pointerEvents: 'none',
                background: '#fff',
                borderRadius: 4,
                flex: 1,
                minWidth: 0
            }}
        />
        <FaCalendar style={{ marginLeft: 8, color: '#495057', flex: '0 0 auto' }} />
    </button>
));

export default function FormularioActividad(){
    const Navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const { token, user, rol, sedeActual } = useAuth();
    const { id, organizacionId } = useParams();
    const { control, handleSubmit, register, setValue, getValues, reset, setError, clearErrors, watch, formState: { errors }} = useForm(
        {
            defaultValues: {
                usuarios_actividad: [],
                borrararchivoanterior: false
            }
        }
    );
    const [swalProps, setSwalProps] = useState({});  
    const [lineasAccion, setLineasAccion] = useState([]);
    const [tiposEvento, setTiposEvento] = useState([]);
    const [tiposEventoCargados, setTiposEventoCargados] = useState([]);
    const [tieneCostoActividad, setTieneCostoActividad] = useState(false);
    const [actividadesEvento, setActividadesEvento] = useState([]);
    const [actividadesEventoCargadas, setActividadesEventoCargadas] = useState([]);
    const [tiposSubactividades, setTiposSubactividades] = useState([]);
    const [tiposSubactividadesCargadas, setTiposSubactividadesCargadas] = useState([]);
    const [usuariosActivos, setUsuariosActivos] = useState([]);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
    const [datosFormulario, setDatosFormulario] = useState(null);
    const [asistentesActividad, setAsistentesActividad] = useState([]);
    const [idPersonaAsistente, setIdPersonaAsistente] = useState(null); 
    

    useEffect(() => {
        if (datosFormulario 
            && actividadesEventoCargadas.length > 0 
            && actividadesEvento.length >= 0
            && tiposEvento.length > 0) {
            reset((prevValues) => ({
                ...prevValues,
                id: datosFormulario?.id || '0',
                act_fecha: datosFormulario?.act_fecha || '',
                act_organizacionid: datosFormulario?.act_organizacionid || '',
                act_tipoeventoid: datosFormulario?.act_tipoeventoid || '',
                act_actividadid: datosFormulario?.act_tipoactividadorgid || '',
                act_valor: datosFormulario?.act_valor || '',
                act_file: datosFormulario?.act_file || null,
                act_observacion: datosFormulario?.act_observacion || '',
                act_filename: datosFormulario?.act_filename || '',
                act_lineaaccionid: datosFormulario?.act_lineaaccionid || '',
                act_nrointegrantes: datosFormulario?.act_nrointegrantes || '',
                act_lugar: datosFormulario?.act_lugar || '',
                act_subactividadid: datosFormulario?.act_subactividadid || '',
            }));
            HabilitarValor();
            setDatosFormulario(null);
        }
    }, [datosFormulario, actividadesEventoCargadas, actividadesEvento, tiposEvento, reset]);

    const fetchData = useCallback(async (id, rol, user) => {       
        const url = '/organizaciones/crearformularioactividad';
        const obj = {id: id, usrRolid: rol, userId: user};
        setCargando(true);
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            setLineasAccion(result.lineasaccion || []);
            const tiposEvento = result.tiposevento || [];
            setTiposEventoCargados(tiposEvento);
            const tiposActividad = result.tiposactividadorg || [];
            setActividadesEventoCargadas(tiposActividad);
            const tiposSubactividades = result.tipossubactividad || [];
            setTiposSubactividadesCargadas(tiposSubactividades);
            
            const usuarios = result.usuariosActivos.map((usuario) => ({value: usuario.id, label: `${usuario.usrNombre}`}));
            setUsuariosActivos(usuarios);
            const selected = (result.actividadUsuarios || []).map((usuario) => {
                const found = usuarios.find(a => String(a.value) === String(usuario.actUserid));
                if (!found) return null;
                return found;
            }).filter(Boolean);
            setUsuarioSeleccionado(selected);
            if (result.actividad) {
                setTiposEvento(tiposEvento.filter(tipo => String(tipo.id) === String(result.actividad.act_tipoeventoid)));
                setActividadesEvento(tiposActividad.filter(act => String(act.tipTipoeventoid) === String(result.actividad.act_tipoeventoid)));
                setTiposSubactividades(tiposSubactividades.filter(sub => String(sub.sub_tipoactividadorgid) === String(result.actividad.act_tipoactividadorgid)));
                setDatosFormulario(result.actividad);
            }
        })
        .catch(error => {
            Mensaje('Crear formulario', `Hubo un error con la carga de datos de la organicacion nro ${id}: ${error}`);
        })
        .finally(() => {
            setCargando(false);
            setValue('id', id);
        });
    }, [token, setValue, setActividadesEventoCargadas, setTiposEventoCargados]);


    const ListarAsistentesActividad = useCallback(async (actividadId) => {
        if (!actividadId) return;
        const url = '/organizaciones/asistentesactividad/' + actividadId;
        setCargando(true);
        await apiService.get(url, token)
        .then(response => {
            const result = response.data;
            setAsistentesActividad(result.asistentes || []);
        })
        .catch(error => {
            Mensaje('Asistentes actividad', `Hubo un error al cargar los asistentes de la actividad nro ${actividadId}: ${error}`);
        })
        .finally(() => {
            setCargando(false);
        });
    }, [token, setAsistentesActividad]);

    useEffect(() => {
        fetchData(id, rol, user);
        ListarAsistentesActividad(id);
    }, [fetchData, ListarAsistentesActividad, id, rol, user]);

    function HabilitarValor(){
        if(getValues('act_actividadid')){
            const selectedActividadId = getValues('act_actividadid');
            const actividad = actividadesEvento.find(act => act.id === selectedActividadId);
            const tieneCosto = actividad ? actividad.tipTienecosto : false;
            setValue('act_valor', tieneCosto ? getValues('act_valor') : 0);
            setTieneCostoActividad(tieneCosto);
        }else{
            setValue('act_valor', 0);
            setTieneCostoActividad(false);
        }
    }
        
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const onSubmit = async (data) => {
        setCargando(true);
        const url = '/organizaciones/guardaractividad';
        data.usrId = user;
        data.act_organizacionid = organizacionId;
        data.usuarios_actividad = Array.isArray(usuarioSeleccionado)
            ? usuarioSeleccionado.map(u => ({ act_userid: Number(u.value) }))
            : [];
        data.borrararchivoanterior = false;
        
        // Validate filename if file is present
        if (data.act_filename) {
            const nameOnly = data.act_filename.replace(/\.[^/.]+$/, ''); // strip extension
            const validName = /^[A-Za-z0-9]+$/.test(nameOnly);
            if (!validName) {
                setCargando(false);
                setError('act_filename', { 
                    type: 'pattern', 
                    message: 'El nombre del archivo sólo debe contener letras y números, sin espacios ni caracteres especiales' 
                });
                return;
            }
        }
        if (data.act_file instanceof File) {
            const maxSize = 12 * 1024 * 1024;

            if (data.act_file.size > maxSize) {
                setCargando(false);
                Mensaje(
                    'Registrar actividad',
                    JSON.stringify('El archivo no puede superar los 12 MB.')
                );
                return;
            }
        }
        
        try {
            // if a file was selected, send multipart/form-data
            if (data.act_file instanceof File) {
                const formData = new FormData();
                Object.keys(data).forEach((k) => {
                    const v = data[k];
                    // append file objects as files, others as strings
                    if (v instanceof File) {
                        formData.append(k, v, v.name);
                    } else if (v !== undefined && v !== null) {
                        formData.append(k, String(v));
                    }
                });
                const response = await apiService.post(url, formData, token);
                if (response.status === 200) {
                    Mensaje('Registrar actividad', JSON.stringify('Se registro el formulario con exito: ' + response.data.actividad.id));
                    Navigate('/organizaciones/'+ organizacionId + '/formularioactividad/' + response.data.actividad.id);
                }
            } else {
                // no file — send JSON as before
                const response = await apiService.post(url, data, token);
                if (response.status === 200) {
                    Mensaje('Registrar actividad', JSON.stringify('Se registro el formulario con exito: ' + response.data.actividad.id));
                    Navigate('/organizaciones/'+ organizacionId + '/formularioactividad/' + response.data.actividad.id);
                }
            }
        } catch (error) {
            if (error.status === 422) {
                Mensaje('Registrar actividad', JSON.stringify(error.response.data.errors));
            } else if (error.status === 409) {
                Mensaje('Registrar actividad', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    
    const ActualizarUsuarioSeleccionado  = usuarios => {
        setUsuarioSeleccionado(usuarios);
    };
    
    async function DescargarArchivo(){
        setCargando(true);
        const filename = getValues('act_filename') || '';
        
        try {
            const response = await apiService.getFile('/organizaciones/downfilepdf', { filename: filename }, token);
            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = `${filename}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            Mensaje('Descargar archivo', `Hubo un error al descargar el archivo ${filename}: ${err}`);
        } finally {
            setCargando(false);
        }
    }

    async function AgregarAsistente(){
        const idPersona = idPersonaAsistente;
        if (!idPersona) {
            Mensaje('Agregar asistente', 'Ingrese número de documento para agregar asistente');
            return;
        }
        setCargando(true);
        try {
            const response = await apiService.post('/organizaciones/agregarasistente', 
                { 
                    fecha: getValues('act_fecha'),
                    lineaAccionId: getValues('act_lineaaccionid'),
                    actividadId: getValues('id'), 
                    idPersona,
                    usrId: user,
                    sede: sedeActual,
                }, token);
            if (response.status === 200) {
                Mensaje('Agregar asistente', 'Asistente agregado con éxito. '+ response.data.message);
                setIdPersonaAsistente('');
                ListarAsistentesActividad(getValues('id'));
            }
        } catch (err) {
            if (err.status === 404) {
                Mensaje('Agregar asistente', 'No se encontró persona con ese número de documento');
            } else if (err.status === 409) {
                Mensaje('Agregar asistente', 'La persona ya está registrada como asistente en esta actividad');
            } else {
                Mensaje('Agregar asistente', `Hubo un error al agregar el asistente: ${err}`);
            }
        } finally {
            setCargando(false);
        }
    }

    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Formulario actividades" idCabezaFamilia={'1'} url={`/organizaciones/${organizacionId}/actividades`} nombreurl="Actividades" nombreform="Formulario" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-info">
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <input hidden {...register('usrId')} />
                                    <input hidden {...register('id')} />                                    
                                    
                                    <div className="row">
                                       <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="act_fecha">Fecha actividad</label>
                                                <div style={{ marginTop: 6 }}>
                                                    <Controller
                                                        control={control}
                                                        name="act_fecha"
                                                        rules={{ required: "Seleccione fecha actividad" }}
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 6, display: 'block', width: '100%' }}>
                                                                <DatePicker
                                                                    placeholderText="fecha actividad"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value ? new Date(field.value) : null}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    wrapperClassName="w-100"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.act_fecha && <p style={{color: 'red'}}>{errors.act_fecha.message || 'Seleccione fecha actividad'}</p>}
                                                </div>
                                            </div>
                                        </div>  
                                    </div>
                                      <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="act_lineaaccionid">Linea de acci&oacute;n</label> 
                                                <select
                                                    className="form-control"
                                                    {...register('act_lineaaccionid', { required: 'Seleccione línea de acción' })}
                                                    onClick={(e) => {
                                                        const selectedLineaAccionId = e.target.value
                                                        if (selectedLineaAccionId) {
                                                            setTiposEvento(tiposEventoCargados.filter(tipo => tipo.tipoLineaaccionid === selectedLineaAccionId));
                                                        } else {
                                                            setTiposEvento([]);
                                                        }
                                                    }}
                                                >
                                                    <option value="">Seleccione línea de acción</option>
                                                    {lineasAccion.map((linea) => (
                                                        <option key={linea.id} value={linea.id}>
                                                            {linea.linea}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.act_lineaaccionid && <p style={{color: 'red'}}>{errors.act_lineaaccionid.message || 'Seleccione línea de acción'}</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="act_tipoeventoid">Tipo acompañamiento</label>
                                                <select
                                                    className="form-control"
                                                    onClick={(e) => {
                                                        const selectedTipoEventoId = e.target.value;
                                                        setValue('act_tipoeventoid', selectedTipoEventoId);
                                                        // update costo/valor and load actividades
                                                        HabilitarValor();
                                                        if (selectedTipoEventoId) {
                                                            setActividadesEvento(actividadesEventoCargadas.filter(act => act.tipTipoeventoid === selectedTipoEventoId));
                                                        } else {
                                                            setActividadesEvento([]);
                                                        }
                                                    }}
                                                    {...register('act_tipoeventoid', { required: 'Seleccione tipo acompañamiento' })}
                                                >
                                                    <option value="">Seleccione tipo acompañamiento</option>
                                                    {tiposEvento.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>
                                                            {tipo.tipEvento}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.act_tipoeventoid && <p style={{color: 'red'}}>{errors.act_tipoeventoid.message || 'Seleccione tipo acompañamiento'}</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="act_actividadid">Actividad</label>
                                                <select
                                                    className="form-control"
                                                    onClick={(e) => {
                                                        const selectedActividadId = e.target.value;
                                                        setValue('act_actividadid', selectedActividadId);
                                                        HabilitarValor();
                                                        if (selectedActividadId) {
                                                            setTiposSubactividades(tiposSubactividadesCargadas.filter(sub => sub.sub_tipoactividadorgid === selectedActividadId));
                                                        } else {
                                                            setTiposSubactividades([]);
                                                        }
                                                    }}
                                                    {...register('act_actividadid', { required: 'Seleccione actividad' })}>
                                                    <option value="">Seleccione actividad</option>
                                                    {actividadesEvento.map((actividad) => (
                                                        <option key={actividad.id} value={actividad.id}>
                                                            {actividad.tipTipoactividad}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.act_actividadid && <p style={{color: 'red'}}>{errors.act_actividadid.message || 'Seleccione actividad evento'}</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="act_subactividadid">Subactividad</label>
                                                <select
                                                    className="form-control"
                                                    onClick={(e) => {
                                                        const selectedSubactividadId = e.target.value;
                                                        setValue('act_subactividadid', selectedSubactividadId);
                                                    }}
                                                    {...register('act_subactividadid')}>
                                                    <option value="">Seleccione subactividad</option>
                                                    {tiposSubactividades.map((subactividad) => (
                                                        <option key={subactividad.id} value={subactividad.id}>
                                                            {subactividad.sub_nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.act_subactividadid && <p style={{color: 'red'}}>{errors.act_subactividadid.message || 'Seleccione subactividad'}</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="act_valor">Incentivo</label>
                                                <input 
                                                    type="number" 
                                                    className="form-control" 
                                                    placeholder="Incentivo"
                                                    disabled={!tieneCostoActividad}
                                                    {...register('act_valor', { required: 'Ingrese incentivo' })} />
                                                {errors.act_valor && <p style={{color: 'red'}}>{errors.act_valor.message || 'Ingrese valor'}</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="act_nrointegrantes">Participantes</label>
                                                <input 
                                                    type="number" 
                                                    className="form-control" 
                                                    placeholder="Participantes"
                                                    {...register('act_nrointegrantes', { required: 'Ingrese participantes' })} />
                                                {errors.act_nrointegrantes && <p style={{color: 'red'}}>{errors.act_nrointegrantes.message || 'Ingrese participantes'}</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="act_lugar">Lugar</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Lugar"
                                                    {...register('act_lugar')} />
                                                {errors.act_lugar && <p style={{color: 'red'}}>{errors.act_lugar.message || 'Ingrese lugar'}</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div id="divUsuarios" className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='usuarioSeleccionado'>Profesionales encargados</label>
                                            <Select
                                                id="usuarioSeleccionado"
                                                value={usuarioSeleccionado}
                                                isMulti
                                                name="usuarioSeleccionado"
                                                options={usuariosActivos}
                                                onChange={ActualizarUsuarioSeleccionado}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999
                                                    })
                                                }}
                                            />
                                            {errors.usuarioSeleccionado && <p style={{ color: 'red' }}>Seleccione campos</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="act_file">Subir archivo PDF</label>
                                                <input
                                                    type="file"
                                                    accept="application/pdf"
                                                    className="form-control"
                                                    multiple={false}
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0] ?? null;
                                                        // reset previous errors/values
                                                        clearErrors('act_file');
                                                        clearErrors('act_filename');
                                                        if (!f) {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            return;
                                                        }
                                                        if (f.type !== 'application/pdf') {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setError('act_file', { type: 'type', message: 'Solo se permiten archivos PDF' });
                                                            return;
                                                        }
                                                        // Validate file size (max 12 MB)
                                                        const maxSize = 12 * 1024 * 1024; // 12 MB
                                                        
                                                        // validate filename: only letters and numbers (no special chars, no spaces)
                                                        const nameOnly = f.name.replace(/\.[^/.]+$/, ''); // strip extension
                                                        const validName = /^[A-Za-z0-9]+$/.test(nameOnly);
                                                        if (!validName || f.size > maxSize) {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setError('act_filename', { type: 'pattern', message: `El nombre del archivo sólo debe contener letras y números, sin espacios ni caracteres especiales y no debe superar los 12 MB` });
                                                            return;
                                                        }

                                                        const reader = new FileReader();
                                                        reader.onload = (ev) => {
                                                            try {
                                                                const dataUrl = ev.target.result || '';
                                                                const base64 = dataUrl.split(',')[1] || '';

                                                                clearErrors('act_file');
                                                                clearErrors('act_filename');
                                                                setValue('act_file', base64, { shouldValidate: true, shouldDirty: true });
                                                                // store only the validated name (keep extension if needed)
                                                                setValue('act_filename', f.name, { shouldValidate: false, shouldDirty: false });
                                                            } catch (err) {
                                                                setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                                setValue('act_filename', '', { shouldValidate: false });
                                                            }
                                                        };
                                                        reader.onerror = () => {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                        };
                                                        reader.readAsDataURL(f);
                                                    }}
                                                    aria-label="Seleccionar archivo (PDF)"
                                                />
                                                <input type='hidden' {...register('act_file')} />
                                                <input type='hidden' {...register('act_filename')} />
                                                {errors.act_file && <p style={{ color: 'red' }}>{errors.act_file.message || 'Ingrese archivo'}</p>}
                                                {errors.act_filename && <p style={{ color: 'red' }}>{errors.act_filename.message || 'Nombre de archivo inválido'}</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Archivo actual</label>
                                                {watch('act_filename') ? (
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0"
                                                            onClick={async () => {
                                                                await DescargarArchivo();
                                                            }}
                                                            aria-label={`Ver archivo ${watch('act_filename')}`}
                                                        >
                                                            {watch('act_filename')}
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <p className="form-control-plaintext">Sin archivo</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="act_observacion">Observacion</label>
                                                <textarea className="form-control" placeholder="Observacion" {...register('act_observacion', {required: 'Ingrese observacion'})} />
                                                {errors.act_observacion && <p style={{color: 'red'}}>{errors.act_observacion.message || 'Ingrese observacion'}</p>}
                                            </div>
                                        </div>
                                    </div>
                                   <input type="hidden" {...register('act_organizacionid')} defaultValue={organizacionId} />
                                    
                                 </div>
                                <div className="card-footer">
                                     {getValues('id') === '0'  && <button type="submit" className="btn btn-primary" style={{ marginRight: 8 }}>Guardar</button>}
                                     <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => Navigate('/organizaciones/'+ organizacionId + '/actividades')}
                                            aria-label="Volver"
                                        >
                                            Volver
                                        </button>
                                 </div>
                                 
                            </form>
                        </div>

                        </div>
                        {/*/.col (left) */}

                    </div>
                    <Card>
                        <CardHeader>
                               <h3>Lista personas asistentes (Registradas en Caracterizaci&oacute;n)</h3>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '10px' }}>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    placeholder="Numero documento..."
                                    style={{ maxWidth: '250px' }}
                                    value={idPersonaAsistente || ''}
                                    onChange={(e) => setIdPersonaAsistente(e.target.value)}
                                />
                                <button type="button" className="btn btn-primary" onClick={() => AgregarAsistente()}>
                                    agregar asistente
                                </button>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ width: '10%' }}>Tipo Documento</th>
                                        <th style={{ width: '10%' }}>Documento</th>
                                        <th style={{ width: '30%' }}>Nombre</th>
                                        <th style={{ width: '30%' }}>Apellido</th>
                                        <th style={{ width: '20%' }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {asistentesActividad.length > 0 ? (
                                        asistentesActividad.map((asistente) => (
                                            <tr key={asistente.id}>
                                                <td>{asistente.TIPODOCUMENTO}</td>
                                                <td>{asistente.DOCUMENTO}</td>
                                                <td>{asistente.PRIMERNOMBRE} {asistente.SEGUNDONOMBRE}</td>
                                                <td>{asistente.PRIMERAPELLIDO} {asistente.SEGUNDOAPELLIDO}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: 'center' }}>No hay asistentes registrados para esta actividad</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}